import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ChatBot from "@/components/feature/ChatBot";
import { ProductProvider } from "@/context/ProductContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ProductProvider>
          <AppRoutes />
          <ChatBot />
        </ProductProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
